export default "__VITE_ASSET__CxSAvAfS__"